export default "__VITE_ASSET__BgLinpjp__"